import AepsBalanceMain from "../../components/aeps-balance-enquiry-reports/AepsBalanceMain"

export const AEPSBalanceReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <AepsBalanceMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}